import connectToRouter from 'js/lib/connectToRouter';
import { useLocation } from 'js/lib/useRouter';

import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export type WithRouterFreeTrialProps = {
  freeTrial?: boolean;
};

/** @deprecated Use useRouterPromoCode instead */
export const withRouterFreeTrial = connectToRouter<WithRouterFreeTrialProps, {}>((router) => {
  const isFreeTrialEnabled = EnterpriseExperiments.get('enableFreeTrial');
  const freeTrial = router.location.query.freetrial === '1';
  return {
    freeTrial: isFreeTrialEnabled && freeTrial,
  };
});

export const useRouterFreeTrial = (): WithRouterFreeTrialProps => {
  const location = useLocation();
  const isFreeTrialEnabled = EnterpriseExperiments.get('enableFreeTrial');
  const freeTrial = location.query.freetrial === '1';
  return {
    freeTrial: isFreeTrialEnabled && freeTrial,
  };
};
